/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ClientEvents from '../../Game/Integrations/ClientEvents';
import StateDependencyComponent from '../../StateManager/StateDependencyComponent';
import StateEvent from '../../StateManager/StateEvent';
import { StateID } from '../../StateManager/StateID';
import StateReference from '../../StateManager/StateReference';
import InjectableComponent from '../../Utility/Component/ComponentReference/InjectableComponent';
import NodeCollection from '../../Utility/Component/ComponentReference/NodeCollection';
import { ReferenceGroup } from '../../Utility/Component/ComponentReference/ReferenceGroup';
import CLog, { LogTypes } from '../../Utility/ComponentLogger';
import ErrorDef from './ErrorDef';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class ErrorForcer extends StateDependencyComponent
{
    @property(StateReference)
    protected loadStateRef: StateReference = new StateReference(StateID.CheckRecall);

    @property(InjectableComponent)
    protected parentNodesRef: InjectableComponent<NodeCollection>
        = new InjectableComponent(ReferenceGroup.MainGame, 'ErrorForcer.Container');

    @property(cc.Prefab)
    protected defPrefab: cc.Prefab = null;

    @property(InjectableComponent)
    protected clientEventsRef: InjectableComponent<ClientEvents> = new InjectableComponent();

    private _errorDefs: ErrorDef[] = null;

    protected setContexts(): void
    {
        super.setContexts();
        this.parentNodesRef.SetContext(NodeCollection);
        this.clientEventsRef.SetContext(ClientEvents);
    }

    protected onLoad(): void
    {
        super.onLoad();

        this._errorDefs = this.getComponentsInChildren(ErrorDef);
        if (!this._errorDefs
            || this._errorDefs.length < 1)
        {
            this.enabled = false;
            CLog.error('No properly configured.', this, LogTypes.Configuration);
        }
        else
        {
            this._errorDefs.forEach(errorDef => errorDef.Parent = this);
        }
    }

    protected start(): void
    {
        super.start(this.loadStateRef);
    }

    protected onStateChangeHandler = (event: StateEvent): void =>
    {
        if (event.State === this.loadStateRef.Value)
        {
            this.loadErrorDefs();
            this.completeState(event.State);
        }
    }

    private loadErrorDefs(): void
    {
        this.parentNodesRef.WithValue(parentNodes =>
            {
                parentNodes.Nodes.forEach(parentNode =>
                    {
                        this._errorDefs.forEach(errorDef =>
                            {
                                const newNode: cc.Node = cc.instantiate(this.defPrefab);
                                newNode.name = errorDef.node.name;
                                errorDef.BindToTarget(newNode);

                                parentNode.addChild(newNode);

                                const label: cc.Label = newNode.getComponent(cc.Label)
                                    || newNode.getComponentInChildren(cc.Label);
                                if (!label) { return; }
                                label.string = errorDef.node.name;
                            });

                        const layout: cc.Layout = parentNode.getComponent(cc.Layout);
                        if (!layout) { return; }
                        layout.updateLayout();
                    });
            }, () => CLog.error('No parent nodes found.', this, LogTypes.Initialization));
    }
}
